export const getSelectedIdsFromGrid = grid =>
  grid?.result?.rowsSelection?.getSelectedData()?.map(item => item.id);
